import React from 'react';

import { isNil } from 'ramda';

import { useTheme } from '@mui/material/styles';
import {
  GridCheckIcon,
  GridRenderCellParams,
  GridValidRowModel
} from '@mui/x-data-grid-pro';

const BooleanCell = (
  props: Pick<GridRenderCellParams<GridValidRowModel>, 'value'>
) => {
  const theme = useTheme();
  /**
   * Show nothing if the value is false
   */
  if (isNil(props.value) || !props.value) {
    return null;
  }

  return (
    <GridCheckIcon
      style={{
        color: theme.palette.success.light
      }}
    />
  );
};

export default BooleanCell;
